/**
 * A person's race, as recorded by the EHR. primary owns this vocabulary. The stored column is an
 * array — a person may have several — and it is unconstrained in the database, so a value outside
 * this set is possible for imported data.
 */
export var Race;
(function (Race) {
    Race["African"] = "AFRICAN";
    Race["AfricanAmerican"] = "AFRICAN_AMERICAN";
    Race["AmericanIndian"] = "AMERICAN_INDIAN";
    Race["Asian"] = "ASIAN";
    Race["AsianIndian"] = "ASIAN_INDIAN";
    Race["Caucasian"] = "CAUCASIAN";
    Race["Chinese"] = "CHINESE";
    Race["Filipino"] = "FILIPINO";
    Race["Guamanian"] = "GUAMANIAN";
    Race["Japanese"] = "JAPANESE";
    Race["Korean"] = "KOREAN";
    Race["MiddleEasternOrNorthAfrican"] = "MIDDLE_EASTERN_OR_NORTH_AFRICAN";
    Race["Other"] = "OTHER";
    Race["PacificIslander"] = "PACIFIC_ISLANDER";
    Race["NativeHawaiian"] = "NATIVE_HAWAIIAN";
    Race["PatientDeclined"] = "PATIENT_DECLINED";
    Race["Samoan"] = "SAMOAN";
    Race["Vietnamese"] = "VIETNAMESE";
    Race["White"] = "WHITE";
    Race["Unavailable"] = "UNAVAILABLE";
    Race["Mixed"] = "MIXED_RACE";
})(Race || (Race = {}));
//# sourceMappingURL=race.js.map